export default "__VITE_ASSET__DrZ6PzHO__"